import React from "react";
import { Drum, Building2, Heart, MapPin, Clock } from "lucide-react";

const days = [
  {
    id: "day-dandali",
    date: "MERCREDI 12 AOÛT 2026",
    title: "Le Dandali",
    time: "À partir de 16h00",
    desc: "Célébrations traditionnelles et festivités dans la joie et l’allégresse.",
    Icon: Drum,
    place: "Concession familiale Alhadji Oumar",
    address: "Quartier Est, Bitam, Gabon",
    mapQuery: "3FJW%2BMHQ+Bitam+Gabon",
  },
  {
    id: "day-religious",
    date: "VENDREDI 14 AOÛT 2026",
    title: "Cérémonie Religieuse",
    time: "14h00",
    desc: "Union spirituelle devant Dieu et nos proches.",
    Icon: Building2,
    place: "Grande Mosquée de Bitam",
    address: "Quartier Est, Bitam, Gabon",
    mapQuery: "Grande+Mosquée+Bitam+Gabon",
  },
  {
    id: "day-civil",
    date: "SAMEDI 15 AOÛT 2026",
    title: "Mariage Civil",
    time: "10h00",
    desc: "Cérémonie civile et grande réception.",
    Icon: Heart,
    place: "Mairie de Bitam",
    address: "3FJR+75, Bitam, Gabon",
    mapQuery: "3FJR%2B75+Bitam+Gabon",
  },
];

export default function Programme() {
  return (
    <section
      id="programme"
      data-testid="programme-section"
      className="relative section-pad"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="gold-rule mb-6">PROGRAMME DES CÉLÉBRATIONS</p>
          <h2 className="font-serif-display text-emerald-deep text-4xl md:text-5xl">
            Trois jours de célébrations
          </h2>
          <p className="font-serif-display italic text-emerald/80 mt-3">
            Du 12 au 15 Août 2026 · Bitam, Gabon · Insha Allah
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {days.map(({ id, date, title, time, desc, Icon, place, address, mapQuery }) => (
            <article
              key={id}
              data-testid={id}
              className="relative bg-cream border border-[#C9A961]/50 p-7 md:p-8 text-center flex flex-col items-center shadow-[0_20px_50px_-25px_rgba(10,61,46,0.45)] transition-transform duration-500 hover:-translate-y-2"
            >
              <p className="text-gold tracking-[0.35em] text-[11px] mb-5">
                {date}
              </p>

              <div
                className="w-24 h-24 rounded-full flex items-center justify-center mb-5"
                style={{
                  background:
                    "radial-gradient(circle at 50% 35%, #1a6a4f 0%, #0a3d2e 100%)",
                  border: "1px solid #C9A961",
                  boxShadow:
                    "inset 0 0 0 4px rgba(201,169,97,0.18), 0 12px 30px -12px rgba(10,61,46,0.6)",
                }}
              >
                <Icon
                  size={36}
                  strokeWidth={1.4}
                  style={{ color: "#E0C384" }}
                />
              </div>

              <h3 className="font-serif-display text-emerald-deep text-2xl md:text-3xl">
                {title}
              </h3>

              <div className="flex items-center gap-2 mt-2 text-emerald-deep">
                <Clock size={14} className="text-[#B8923D]" />
                <p className="font-serif-display text-lg">{time}</p>
              </div>

              <div className="divider-ornament my-4">
                <span className="line" />
                <span className="dot" />
                <span className="line" />
              </div>

              <p className="font-serif-display italic text-emerald/80 px-1 mb-5">
                {desc}
              </p>

              {/* Per-event location */}
              <div
                className="w-full mt-auto pt-5 border-t border-[#C9A961]/30 text-center"
                data-testid={`${id}-location`}
              >
                <div className="flex items-start justify-center gap-2 text-emerald-deep">
                  <MapPin size={16} className="text-[#B8923D] mt-[3px] flex-shrink-0" />
                  <div>
                    <p className="font-serif-display text-base font-semibold">
                      {place}
                    </p>
                    <p className="font-serif-display italic text-emerald/75 text-[15px]">
                      {address}
                    </p>
                  </div>
                </div>

                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`${id}-map`}
                  className="mt-4 inline-flex items-center gap-2 text-[11px] tracking-[0.3em] font-semibold text-[#B8923D] hover:text-[#8a6a1f] transition-colors"
                >
                  VOIR SUR LA CARTE <MapPin size={14} />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
